module.exports = __webpack_public_path__ + "img/appointmentSucceed.13561727.png";